export interface ConfirmDialogData {
  /** Dialog title */
  title: string;

  /** Main message */
  description?: string;

  /** Primary button text – defaults to “Yes” for confirm, “Okay” for alert */
  action?: string;

  /** Tailwind background class for the primary button */
  buttonColor?: string;

  /** Tailwind text colour class for the primary button */
  buttonTextColor?: string;

  /** Visual style of the dialog */
  showType?: AlertType;

  /** When `true` the dialog works as a simple **alert** (only one button) */
  alertMode?: boolean;
}

export enum AlertType {
  info = 'info',
  warning = 'warning',
  error = 'error',
  success = 'success',
}
